import { useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { registrationEntryLinkResponseSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

export const useAPIGetRegistrationEntryLink = (
  locale: string,
  resetOldUser: boolean
) =>
  useMutation({
    mutationFn: () =>
      get(
        `${API_ENDPOINTS.REGISTRATION_ENTRY_LINK}?locale=${locale}&resetOldUser=${resetOldUser}`,
        registrationEntryLinkResponseSchema
      ),
  })
